// extracted by mini-css-extract-plugin
export var accent = "_6g-4";
export var add = "_6g-j";
export var addIcon = "_6g-k";
export var deleteIcon = "_6g-i";
export var disabled = "_6g-9";
export var ellipsis = "_6g-f";
export var error = "_6g-3";
export var form = "_6g-5";
export var hideFocus = "_6g-2";
export var icon = "_6g-7";
export var input = "_6g-e";
export var listItem = "_6g-h";
export var mediumHeight = "_6g-b";
export var noBorder = "_6g-8";
export var noRadius = "_6g-1";
export var shortHeight = "_6g-a";
export var tallHeight = "_6g-c";
export var textInput = "_6g-0";
export var vertical = "_6g-g";
export var veryTallHeight = "_6g-d";
export var widget = "_6g-6";